import React, { useState } from 'react'
import styles from './style.module.css'
import Product_3 from '../Product_3/Product_3';
import Product_2 from '../Product_2/Product_2';
import SoftwareImage from '../../Images/lap-and-phone.png';
import Heading from '../../components/Heading';
import SubHeading from '../../components/SubHeading';
import BulletList from '../../components/BulletList';

interface PartnerProps {
  headerVis: boolean;
  textAlignment: string;
  chargerType: string;
}

const Product_1: React.FC<PartnerProps> = ({headerVis, textAlignment, chargerType}) => {
  const [headerVisibility, setHeaderVisibility] = useState(headerVis)
  const [contentSelector, setContentSelector] = useState('software')

  let hardwareContent =
   (
      <>
        <div className={styles['product1-header-sub-container']}>
          <span className={styles['pill-header']}>
            Hardware Solutions
          </span>
          {/* <div className={styles['product1-main-heading-2']}>
            High-Performance Charging Hardware
          </div> */}
          <Heading topBottomMargin>High-Performance Charging Hardware</Heading>
          <div className={styles['product1-sub-heading-2']}>
            Our sleek, reliable charging stations are designed for efficiency, durability, and minimal
            maintenance. Choose between various power options to meet your property's unique needs.
          </div>
        </div>
        <div className={`${styles['product1-content-container']} ${styles['flex-column']}`}>
          {/* <div className={styles['product1-content-image']}>
                <span className={styles['product1-content-image-txt']}>22kW Max</span>
              </div> */}

          
          <div className={styles['product1-content-text']}>
            <div className={styles['product1-content-header']}>
              Level 2 AC Chargers
            </div>
            <p className={styles['product1-content-para']}>
              The optimal solution for most properties.
              Our Level 2 chargers deliver reliable, cost-effective charging for everyday use.
            </p>

            <BulletList items={
                  [
                      'Ideal for workplace and residential properties',
                      '7.7kW - 19.2kW power options available',
                      'Cost-effective installation and operation',
                      'Minimal maintenance requirements',
                      'Remote monitoring and diagnostics',
                  ]
            } />

            {/* <div className={styles['product1-button-container']}>
                  <button className={styles['product1-button']}>Explore Level 2 Chargers</button>
                  <button className={styles['product1-button']}>View Specs</button>
                </div> */}
          </div>
          <div className={styles['product1-content-text']}>
            <div className={styles['product1-content-header']}>
              Level 3 DC Fast Chargers
            </div>
            <p className={styles['product1-content-para']}>
              Premium performance for high-traffic areas.
              Our Level 3 DC fast chargers deliver exceptional charging speeds when time is of the essence.
            </p>

            <BulletList items={
                [
                    'Perfect for high-traffic commercial locations',
                    '50kW - 350kW ultra-fast charging',
                    'Serves multiple vehicles efficiently',
                    'Built-in cable management system',
                    'Advanced thermal management',
                ]
            } />

            
            {/* <div className={styles['product1-button-container']}>
             <button className={styles['product1-button']}>Explore Level 3 Chargers</button>
             <button className={styles['product1-button']}>View Specs</button>
           </div> */}
          </div>
        </div>
      </>
   ) 
  let softwareContent =
    (
      <>
        <div className={styles['product1-header-sub-container']}>
          <span className={styles['pill-header']}>
            Software Solutions
          </span>
          {/* <div className={styles['product1-main-heading-2']}>
          BreatheEV Management Software
          </div> */}
          <Heading topBottomMargin>BreatheEV Management Software</Heading>
          {/* <SubHeading>Already have chargers? Let BreatheEV add new features, lower costs and increase revenue generation</SubHeading> */}
          <div className={styles['product1-sub-heading-2']}>
            Already have chargers? Let BreatheEV add new features, lower costs and increase revenue generation
          </div>
        </div>
        <div className={`${styles['product1-content-container']} ${styles['flex-column']}`}>
          <div className={styles['product1-content-image']}>
            {/* <img src={SoftwareImage} className={styles['product1-content-image-body']}></img> */}
            {/* <span className={styles['product1-content-image-txt']}>22kW Max</span> */}
          </div>
          <div className={styles['product1-content-text']}>
            <div className={styles['product1-content-header']}>
              Management Software
            </div>
            <p className={styles['product1-content-para']}>
              BreatheEV’s management software allows you to connect to our network while we handle pricing, billing, user management, network connectivity 
              and more, all while introducing attractive features.
            </p>

            <BulletList items={
                    [
                        'Reservation-Enabled Charging',
                        'Live Status Dashboard',
                        'Utilization and Uptime Reporting',
                        'Multi-Site Management for Portfolios',
                        'Secure Payment Integration',
                        '$0 annual fee with no monthly subscription charges',
                    ]
                } />

          </div>
          
        </div>
      </>
     )
  return (
    <div className={`${styles['product1-main-container']} page-top-margin`}> 
      <div className='container'>
        {
          headerVis &&
          <div className={styles['product1-header-container']}>
            <span className={styles['pill-header']}>
              Revolutionizing EV Charging
            </span>
            {/* <div className={styles['product1-main-heading-1']}>
              Complete EV Charging <br className={styles['heading-1-break']}/> Solutions for Modern Properties
            </div> */}
            <Heading className='mt-3 mb-3'>
              Complete EV Charging <br className={styles['heading-1-break']}/> Solutions for Modern Properties
            </Heading>
            {/* <div className={styles['product1-sub-heading-1']}>
              Seamlessly integrate cutting-edge hardware and intelligent software
                to create the ultimate charging experience.
              </div> */}
              <SubHeading topBottomMargin>
              Seamlessly integrate cutting-edge hardware and intelligent software
              to create the ultimate charging experience.
              </SubHeading>
              <div className={styles['product1-button-container']}>
                <button
                  className={`${styles['product1-button']} 
                ${contentSelector === 'software' ? styles['selected'] : ""}`}
                onClick={() =>{setContentSelector('software')}}
                >
                  Discover Software
                </button>
                <button className={`${styles['product1-button']} 
                ${contentSelector === 'hardware' ? styles['selected'] : ""}`}
                onClick={() =>{setContentSelector('hardware')}}
                >
                  Explore Hardware
                </button>
              </div>


          </div>
        }
        <div>
          {/* {textAlignment === 'right' ?
            contentLevel2
            :
            contentLevel3
          } */}
          {
            contentSelector === 'software' ?
              <>
                {softwareContent}
                <Product_2 type={'software'}></Product_2>
              </>
              :
              <>
              {hardwareContent}
              <Product_2 type={'hardware'}></Product_2>
              </>
          }
          
        </div>
      </div>
    </div>

  )
}

export default Product_1